import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';
declare const $: any;
@Component({
  selector: 'app-bookmark',
  templateUrl: './bookmark.component.html',
  styleUrls: ['./bookmark.component.scss']
})
export class BookmarkComponent extends ManikEntityFE implements OnInit, OnChanges {
  BookmarkForm: FormGroup;
  WebSiteMetaData: any = {};
  UserLoggedIn: boolean;
  @Input() VisitorData: any;
  @Output() VisitorLoggedIn = new EventEmitter();
  submitted: boolean = false;
  populateControls(): void {
    throw new Error("Method not implemented.");
  }
  refreshDataGrid(param: any): void {
    throw new Error("Method not implemented.");
  }

  constructor(private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.BookmarkForm = this.formBuilder.group({
      VisitorID: ['']
    });
  }

  ngOnInit() {
    this.WebSiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
    this.CheckUserLoggedIn();
  }

  Emit() {
    this.VisitorLoggedIn.emit('Y');
  }

  ngOnChanges() {
    this.CheckUserLoggedIn();
  }

  Bookmark() {
    this.submitted = true;
    let body = this.BookmarkForm.value;
    body['BusinessHandle'] = this.WebSiteMetaData.BizHandle;
    let SubmittedData = JSON.stringify({ "items": [body] });
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmittedData,
      this.prepareManageHeaders2("A", "VISITOR.BOOKMARKS", "MANIK.GLOBAL"))
      .subscribe(data => {
        //let id = data.ManikJSon[0].JSon0[0].NewEntity;
        $("#lblMessage").text("Bookmarked!");
        $("#lblMessage").show();
        setTimeout(() => {
           $("#lblGMessage").hide();
          $('#BookmarkBusiness').modal('hide');
        }, 1000);
        this.submitted = false;
      });
  }

  CheckUserLoggedIn() {
    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      if (x) {
        if (x.VisitorName) {
          this.UserLoggedIn = true;
          this.BookmarkForm.controls['VisitorID'].setValue(x.VisitorID);
        }
        else {
          this.UserLoggedIn = false;
        }
      }
      else {
        this.UserLoggedIn = false;
      }
    }
  }

}
